<template>
	<div :class="'v'+v+' lang-'+$i18n.locale">
		<!-- s1 -->
		<div class="relative text-white">
			<img v-if="sm" class="w-full" :src="assets.s12" style="min-height: 583px;" />
			<img v-else class="w-full" :src="assets.s11" style="min-height: 900px;" />
			<div class="absolute f fy fcc left-0 w-full" :style="sm?'top:13%;':'top:111px;'">
				<div class="relative text-center f60 sm-f32 " :style="sm?'width:15em;':'width:16em;'">
					<span :class="v=='b'?'text-line-bg':''" v-html="sv('s11',true)"></span>
				</div>
				<div :class="sm?'relative ff-Noto-Sans-JP text-center f20 sm-f16 mt-3':'relative ff-Noto-Sans-JP text-center f20 sm-f16 mt-3'"
					style="color:#F4F4F2;width:20em;">
					<span class="" :style="v=='b'?'color:#FFA283;':''" v-html="sv('s12',true)"></span>

				</div>
			</div>
			<div class="absolute f fy fcc left-0 w-full" :style="sm?'bottom:38px;':'bottom:194px;'">

				<div :class="sm?'btn f fx fcc fmc btn-primary f20 oh':'btn f fx fcc fmc btn-primary f20 oh'"
					:style="sm?'height:55px;border-radius:30px;margin-top:150px;':'height:55px;border-radius:30px;margin-top:300px;'"
					@click="scrollIntoView">
					<div class="relative f fx fcc">
						{{s('btn11')}}
						<span class="mx-0-5 bolder f28" style="color: #FF0004;">{{s('btn12')}}</span>
						{{s('btn13')}}
						<img class="relative inline-block ml-0-5" style="height:0.8em;" src="@/assets/share.png" />

					</div>

				</div>
			</div>
		</div>
		<!-- s2 -->
		<div class="relative ff-Noto-Sans-JP mt-6 lh-1-2"
			:style="sm?'height:500px;font-size:14px;':'height:611px;font-size:16px;'">
			<img class="absolute z-1 w-full cy left-0" src="@/assets/saima/s20.png"
				:style="sm?'height:246px;':'height:576px;'" />
			<div class="main text-center absolute z-2 top-0 h-full cx">

				<div class="absolute" :style="sm?'top:64px;right:55%;':'top:10%;left:15%;'">
					<img id="s21" :src="assets.s21" class="scale-element flower-swing"
						:style="sm?'width:141px;':'width:236px;'" @mouseenter="send_hover_expression_event(1)"
						@click="send_hover_expression_event(1)" />
					<div class="absolute  top-full mt-1 cx" :style="sm?'width:18em;left:60%;':'width:20em;'"
						v-html="sv('s22',true)">
					</div>
				</div>
				<div class="absolute" :style="sm?'top:0;left:60%;':'top:0;right:15%;'">
					<img id="s22" :src="assets.s22" class="scale-element flower-swing2"
						:style="sm?'width:98px;':'width:163px;'" @mouseenter="send_hover_expression_event(2)"
						@click="send_hover_expression_event(2)" />
					<img class="absolute cy"
						:style="sm?'width:85px;top:30%;right:80%;':'width:107px;top:30%;right:80%;'"
						src="@/assets/saima/s25.png" />
					<div class="absolute top-full mt-1 cx" :style="sm?'width:16em;':'width:20em;'"
						v-html="sv('s21',true)">
					</div>
				</div>
				<div class="absolute" :style="sm?'bottom:64px;right:55%;':'bottom:4%;left:28%;'">
					<img id="s23" :src="assets.s23" class="scale-element flower-swing"
						:style="sm?'width:141px;':'width:167px;'" @mouseenter="send_hover_expression_event(3)"
						@click="send_hover_expression_event(3)" />
					<div class="absolute top-full mt-1 cx" :style="sm?'width:18em;left:60%;':'width:20em;'"
						v-html="sv('s24',true)">
					</div>
				</div>
				<div class="absolute" :style="sm?'bottom:164px;left:60%;':'bottom:17%;right:25%;'">
					<img id="s24" :src="assets.s24" class="scale-element flower-swing2"
						:style="sm?'width:100px;':'width:282px;'" @mouseenter="send_hover_expression_event(4)"
						@click="send_hover_expression_event(4)" />
					<div class="absolute top-full mt-1 cx" :style="sm?'width:18em;':'width:20em;'"
						v-html="sv('s23',true)">
					</div>
				</div>

			</div>
		</div>
		<!-- s3 -->
		<!-- <div class="main mt-8 px-2">
				<img class="relative block w-full" src="@/assets/saima/s31.png" />
			
			</div> -->
		<!-- s4 -->
		<div class="relative ff2 mt-8 main f14">
			<div class="relative text-center f32 mx-auto" :style="sm?'width:10em;':''">
				{{sv('s40')}}
			</div>
			<div :class="sm?'relative mt-3 cmt-2 px-2':'relative mt-3 cml-5 f fx'">
				<div class="f-1 relative f fy fcc">
					<img :src="assets.s41" class="relative scale-element w-full" style="" />
					<div class="relative text-center mt-1-5">
						{{sv('s411')}}
					</div>
					<div class="relative text-center mt-1-5 text-gray">
						{{sv('s412')}}
					</div>
				</div>
				<div class="f-1 relative f fy fcc">
					<img :src="assets.s42" class="relative scale-element w-full" style="" />
					<div class="relative text-center mt-1-5">
						{{sv('s421')}}
					</div>
					<div class="relative text-center mt-1-5 text-gray">
						{{sv('s422')}}
					</div>
				</div>
				<div class="f-1 relative f fy fcc">
					<img :src="assets.s43" class="relative scale-element w-full" style="" />
					<div class="relative text-center mt-1-5">
						{{sv('s431')}}
					</div>
					<div class="relative text-center mt-1-5 text-gray">
						{{sv('s432')}}
					</div>
				</div>

			</div>
		</div>
		<!-- s5 -->
		<div class="relative mt-8 main2 f14">
			<div class="relative text-center f32 mx-auto" :style="sm?'width:10em;':''">
				{{sv('s50')}}
			</div>

			<div :class="sm?'relative ff2 mt-3 cmt-3 mx-3':'relative ff2 mt-3 cml-5 f fx'">

				<div class="f-1 relative f fy fcc" style="background-color: #F4F4F2;">
					<img src="@/assets/saima/s51.png" style="mix-blend-mode: multiply;width:100px;height:100px;" />
					<div class="relative text-center mt-1-5">
						{{sv('s51')}}
					</div>
				</div>
				<div class="f-1 relative f fy fcc" style="background-color: #F4F4F2;">
					<img src="@/assets/saima/s52.png" style="mix-blend-mode: multiply;width:100px;height:100px;" />
					<div class="relative text-center mt-1-5">
						{{sv('s52')}}
					</div>
				</div>
				<div class="f-1 relative f fy fcc" style="background-color: #F4F4F2;">
					<img src="@/assets/saima/s53.png" style="mix-blend-mode: multiply;width:100px;height:100px;" />
					<div class="relative text-center mt-1-5">
						{{sv('s53')}}
					</div>
				</div>

			</div>

			<div class="relative f fx mt-4 f14" style="color: #282622;">
				<div class="f-1 relative f fy">
					<div class="relative text-center text-primary f32 bolder">
						100+
					</div>
					<div class="relative ff2 text-center">
						{{sv('s54')}}
					</div>
				</div>
				<div class="f-1 relative f fy">
					<div class="relative text-center text-primary f32 bolder">
						99%
					</div>
					<div class="relative ff2 text-center">
						{{sv('s55')}}
					</div>
				</div>
				<div class="f-1 relative f fy">
					<div class="relative text-center text-primary f32 bolder">
						2026
					</div>
					<div class="relative ff2 text-center">
						{{sv('s56')}}
					</div>
				</div>

			</div>
			<div id="target" v-if="rules" class="main3 f fy cmt-2 mt-4 mb-10 px-2">
				<el-form ref="form" :model="form" :rules="rules">
					<el-form-item prop="email">
						<!-- <el-autocomplete v-model="form.email" class="relative z-2 block w-full" style="height:48px;"
								:fetch-suggestions="querySearch" :placeholder="s('e0')"></el-autocomplete> -->
						<el-input v-model="form.email" class="relative z-2 block w-full"
							:placeholder="s('e0')"></el-input>
					</el-form-item>
				</el-form>
				<div class="btn f fx fcc fmc btn-primary block f20" style="height:48px;" @click="submit">
					{{s('btn1')}}
					<div v-if="err" class="absolute top-full left-0 mt-0-5 pl-0-5 text-primary f12">
						{{err}}
					</div>
					<div v-else-if="suc" class="absolute top-full left-0 mt-0-5 pl-0-5 text-success f12">
						{{suc}}
					</div>
				</div>
			</div>
		</div>

		<Footer :style="v=='a'?'background-color:#7A634E':'background-color:#AE96AF'"></Footer>

	</div>
</template>

<script>
	import HomeLayout from '@/layout/HomeLayout.vue'
	import Footer from '@/layout/Footer.vue';
	import mixin from '@/utils/mixin';

	import s11a from '@/assets/saima/s11a.png'
	import s12a from '@/assets/saima/s12a.png'
	import s21a from '@/assets/saima/s21a.png'
	import s22a from '@/assets/saima/s22a.png'
	import s23a from '@/assets/saima/s23a.png'
	import s24a from '@/assets/saima/s24a.png'
	import s41a from '@/assets/saima/s41a.png'
	import s42a from '@/assets/saima/s42a.png'
	import s43a from '@/assets/saima/s43a.png'

	import s11b from '@/assets/saima/s11b.png'
	import s12b from '@/assets/saima/s12b.png'
	import s21b from '@/assets/saima/s21b.png'
	import s22b from '@/assets/saima/s22b.png'
	import s23b from '@/assets/saima/s23b.png'
	import s24b from '@/assets/saima/s24b.png'
	import s41b from '@/assets/saima/s41b.png'
	import s42b from '@/assets/saima/s42b.png'
	import s43b from '@/assets/saima/s43b.png'

	export default {
		mixins: [mixin],
		components: {
			HomeLayout,
			Footer,
		},
		props: ['v', 'saima'],
		data() {
			return {
				err: '',
				suc: '',
				assets: {},
				texts: {

				},
				rules: null,
				form: {
					email: '',
				}
			}
		},
		mounted() {

			this.rules = {
				email: [{
						required: true,
						message: this.s('e1'),
						trigger: 'blur'
					}, {
						type: 'email',
						message: this.s('e2'),
						trigger: 'blur'
					} // 格式验证
				]
			};

			if (this.v == 'a') {
				this.assets = {
					s11: s11a,
					s12: s12a,
					s21: s21a,
					s22: s22a,
					s23: s23a,
					s24: s24a,
					s41: s41a,
					s42: s42a,
					s43: s43a,
				}
				this.text = {}
			} else if (this.v == 'b') {
				this.assets = {
					s11: s11b,
					s12: s12b,
					s21: s21b,
					s22: s22b,
					s23: s23b,
					s24: s24b,
					s41: s41b,
					s42: s42b,
					s43: s43b,
				}
			}



		},
		methods: {

			querySearch(queryString, cb) {

				cb([
					'@gmail.com',
					'@outlook.com',
					'@hotmail.com',
					'@yahoo.co',
					'@protonmail.com',
					'@icloud.com',
					'@qq.com',
					'@163.com',
					'@126.com',
					'@139.com',
					'@189.cn',
				].map(item => ({
					value: (queryString || '').split('@')[0] + item
				})));
			},



			scrollIntoView() {
				// dataLayer.push({
				// 	'event': 'submit_email'
				// });
				// if (this.saima) {
				// 	gtag('event', 'view_offer_section', {
				// 		'page_url': window.location.href
				// 	});
				// }

				// 获取目标元素
				const targetElement = document.getElementById('target');

				// 平滑滚动到该元素（默认对齐顶部）
				targetElement.scrollIntoView({
					behavior: 'smooth', // 平滑滚动
					block: 'start' // 元素顶部与视口顶部对齐（默认值）
				});

				this.send_view_offer_section_event();
			},

			submit() {

				this.err = '';
				this.suc = '';

				// this.$alert(this.s('success'), '', {
				// 	confirmButtonText: '确定',
				// 	type: 'success',
				// 	center: true,
				// });

				// return;


				this.$refs.form.validate((valid) => {
					if (valid) {
						request({
							url: '/api/form/createFormData',
							data: {
								formId: 101,
								fields: [{
									key: 'email',
									value: this.form.email,
								}, {
									key: 'v',
									value: this.v,
								}, {
									key: 'lang',
									value: this.$i18n.locale,
								}, {
									key: 'href',
									value: location.href,
								}]
							},
							success: resp => {
								this.suc = this.s('success');
								this.success(this.s('success'));
								this.send_submit_email_event()
							},
							fail: resp => {
								let err = '';
								if (resp && resp.msg && resp.msg.startsWith('e')) {
									err = this.s(resp.msg);
								} else {
									err = this.s('error');
								}
								this.error(err);
								this.err = err;
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});


			},

			s(key, sp) {
				return sp && this.sm ? this.$t('saima.' + key + '_sm') : this.$t('saima.' + key);
			},
			sv(key, sp) {
				return sp && this.sm ? this.$t('saima.' + this.v + '.' + key + '_sm') : this.$t('saima.' + this.v + '.' +
					key);
			},




			send_switch_language_event() {
				if (this.saima && window.gtag) {
					gtag('event', 'switch_language', {
						'page_url': window.location.href
					});
				}
			},
			send_submit_email_event() {
				if (this.saima && window.gtag) {
					gtag('event', 'submit_email', {
						'page_url': window.location.href
					});
				}
			},
			send_view_offer_section_event() {
				if (this.saima && window.gtag) {
					gtag('event', 'view_offer_section', {
						'page_url': window.location.href
					});
				}
			},
			send_hover_expression_event(val) {
				if (this.saima && window.gtag) {
					gtag('event', 'hover_expression', {
						'page_url': window.location.href,
						custom_param1: val
					});
					gtag('event', 'hover_expression_' + val, {
						'page_url': window.location.href,
					});
				}
			},




		}
	}
</script>

<style scoped>
	.text-primary {
		color: #E9918E !important;
	}

	.bg-primary {
		background-color: #E9918E !important;
	}

	.btn.btn-primary {
		color: white;
		background-color: #E9918E;
	}

	.vb .btn.btn-primary {
		background-color: #FFA283;
	}

	.btn.btn-primary:hover {
		background-color: #E37874 !important;
	}

	.text-gray {
		color: #28262280 !important;
	}

	.no-wrap-text {
		white-space: nowrap;
		/* 可选：添加溢出处理 */
		overflow: hidden;
		text-overflow: ellipsis;
		/* 当内容溢出时显示省略号 */
	}



	/* 基础样式 */
	.scale-element {

		/* 关键：添加过渡动画，使变化平滑 */
		transition: transform 0.3s ease !important;
		/* 0.3秒过渡，ease缓动函数 */
	}

	/* 鼠标悬浮时放大到110% */
	.scale-element:hover {
		transform: scale(1.1) !important;
		transition: transform 0.3s ease !important;
		/* 放大到110% */
		animation: none;
	}


	.text-line-bg {
		display: inline;
		/* 关键：行内元素，背景随文字换行 */
		background-color: #AE96AF;
		/* 文字背景色（浅黄示例） */
		padding: 2px 4px;
		/* 文字周围留白，避免背景太紧凑 */
		line-height: 1.8;
		/* 增大行高，确保行与行之间的背景不重叠 */
		box-shadow: 1rem 0px 0px #AE96AF, -1rem 0px 0px #AE96AF;
		/* 左侧和右侧阴影颜色为背景色 */
		box-decoration-break: clone;
		/* 让背景与阴影在换行时进行克隆 */
	}


	/* 花朵浮动摇摆动画 */
	.flower-swing {
		/* 确保动画基于元素中心旋转/位移 */
		transform-origin: center bottom;
		/* 模拟花茎底部固定，上部摇摆 */
		animation: swingFloat 3s ease-in-out infinite;
	}

	/* 动画关键帧：上下浮动+左右摇摆结合 */
	@keyframes swingFloat {
		0% {
			transform: translateY(0) rotate(0deg);
			/* 初始位置 */
		}

		25% {
			transform: translateY(-10px) rotate(2deg);
			/* 上浮+右摆 */
		}

		50% {
			transform: translateY(0) rotate(0deg);
			/* 回到中间 */
		}

		75% {
			transform: translateY(-10px) rotate(-2deg);
			/* 上浮+左摆 */
		}

		100% {
			transform: translateY(0) rotate(0deg);
			/* 回到初始位置 */
		}
	}

	/* 花朵浮动摇摆动画 */
	.flower-swing2 {
		/* 确保动画基于元素中心旋转/位移 */
		transform-origin: center bottom;
		/* 模拟花茎底部固定，上部摇摆 */
		animation: swingFloat2 3s ease-in-out infinite;
	}

	/* 动画关键帧：上下浮动+左右摇摆结合 */
	@keyframes swingFloat2 {
		0% {
			transform: translateY(0) rotate(0deg);
			/* 初始位置 */
		}

		25% {
			transform: translateY(-10px) rotate(-2deg);
			/* 上浮+右摆 */
		}

		50% {
			transform: translateY(0) rotate(0deg);
			/* 回到中间 */
		}

		75% {
			transform: translateY(-10px) rotate(2deg);
			/* 上浮+左摆 */
		}

		100% {
			transform: translateY(0) rotate(0deg);
			/* 回到初始位置 */
		}
	}
</style>